import { Flex } from "@redotech/redo-web/flex";
import { AnimatedSkeletonBlock } from "@redotech/redo-web/skeleton";
import { RateSourceSelectionOptionSkeleton } from "./rate-source-selection-option-skeleton";

interface RateSourceSelectionSectionSkeletonProps {
  rowWidths: string[];
  showSectionTitle?: boolean;
}

export function RateSourceSelectionSectionSkeleton({
  rowWidths,
  showSectionTitle = true,
}: RateSourceSelectionSectionSkeletonProps) {
  return (
    <Flex dir="column" gap="sm">
      {showSectionTitle && (
        <AnimatedSkeletonBlock height="14px" width="112px" />
      )}
      <Flex dir="column" gap="sm">
        {rowWidths.map((width, index) => (
          <RateSourceSelectionOptionSkeleton
            key={`${width}-${index}`}
            width={width}
          />
        ))}
      </Flex>
    </Flex>
  );
}
